import Api from '@/services/Api';

export default {
  getClients(page, filter, order, searchFilter, searchTerm) {
    return Api().get('b3/clients', {
      params: {
        page,
        filter,
        order,
        searchFilter,
        searchTerm,
      },
    });
  },
  getClientInfo(id) {
    return Api().get('client', {
      params: {
        id,
      },
    });
  },
};
